<template>
  <div class="platformLabel">

    <div class="platformLabel_buttonArea">
      <!-- <el-button type="primary" style="margin-right:10px" @click="searchLabel = true">添加平台标签</el-button>
      <el-input v-model="input" placeholder="请输入平台" style="width:200px" @change="myInput" /> -->
    </div>

    <div class="platformLabel_contentArea">
      <el-table
        v-loading="loading"
        border
        :data="list"
        style="width: 100%"
      >
        <el-table-column
          prop="platformName"
          label="平台"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.platformName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tagsName"
          label="标签"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.tagsName.join('，  &nbsp;&nbsp;') }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="tagType"
          label="类型"
        /> -->
        <!-- <el-table-column
          label="操作"
          fixed="right"
          width="120"
        >
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="(labelDetails = true),(activeItem = scope.row)">详情</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <!-- <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </div>

    <AddPlatformLabel v-if="searchLabel" :base-tag="baseTag" :platforms="platforms" @colse="close" />
  </div>
</template>

<script>
// import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList/* , addPlatformLabel */, getPlatform } from '@/api/platformLabel.js'
import AddPlatformLabel from './components/addPlatformLabel.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    /* PaginationRight, */
    AddPlatformLabel
  },
  mixins: [convertToHump],
  data() {
    return {
      pageIfon: {
        pageSize: 10,
        page: 1,
        groupName: undefined,
        adminId: undefined
      },
      list: [],
      loading: false,
      total: null,
      baseTag: {},
      activeItem: null,
      searchLabel: false,
      platformId: '',
      input: '',
      platforms: [] // 平台组
    }
  },
  created() {
    this.getLabelGroupList()
    // this.getPlatform()
  },
  methods: {
    fetchPageSize(num) {
      this.pageIfon.pageSize = num
      this.getLabelGroupList()
    },
    fetchCurrentPage(num) {
      this.pageIfon.page = num
      this.getLabelGroupList()
    },
    async getLabelGroupList(ite = { platformId: undefined }) {
      this.loading = true
      const data = await getList({ ...this.pageIfon, ...ite })
      this.loading = false
      this.list = this.convertToHump(data.data)
      console.log(this.convertToHump(data.data), '==')
      /* this.total = data.data.total
      this.baseTag = this.convertToHump(data.data.base_tag) */
    },
    close(bool) {
      this.searchLabel = false
      if (bool) {
        this.getLabelGroupList()
      }
    },
    async getPlatform() {
      const data = await getPlatform()
      this.platforms = data.data.list
    },
    async myInput(event) {
      this.pageIfon.page = 1
      const newArr = event ? this.platforms.filter(item => item.name.includes(event)) : undefined
      this.getLabelGroupList({ platformId: newArr && newArr.length ? newArr[0].id : newArr })
    }
  }
}
</script>

<style scoped lang="less">
.platformLabel{
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
   .platformLabel_buttonArea{
     margin: 10px;
     display: flex;
   }
   .platformLabel_contentArea{

   }
}
</style>
